import { useMemo } from 'react'

import { SanityImageFragment } from '@data/sanity/queries/types/image'
import { SanityPrintSlotSettings } from '@data/sanity/queries/types/print'
import { getPrintPreviewImageWithAreas } from '@lib/print/preview'

import Photo from '@components/photo'
import UploadStepPrintPreviewArea from './print-preview-area'

interface UploadStepPrintPreviewProps {
  printSlot?: SanityPrintSlotSettings
  previewImage?: SanityImageFragment
  className?: string
}

const UploadStepPrintPreview = ({
  printSlot,
  previewImage,
  className,
}: UploadStepPrintPreviewProps) => {
  const imageWithAreas = useMemo(() => {
    if (!printSlot) {
      return
    }

    return getPrintPreviewImageWithAreas(printSlot)
  }, [printSlot])

  const areas = imageWithAreas?.areas ?? []

  return (
    <div className={className}>
      {!!printSlot && !!imageWithAreas && (
        <div className="relative overflow-hidden">
          {areas.map((area) => (
            <UploadStepPrintPreviewArea
              key={area.type}
              area={area}
              printSlotType={printSlot.type}
              printColor={printSlot.previewAreaColor}
              previewImage={previewImage}
            />
          ))}

          <Photo image={imageWithAreas.image} />
        </div>
      )}
    </div>
  )
}

export default UploadStepPrintPreview
